module.exports = __webpack_public_path__ + "static/Gebrauchstauglichkeitsakte_Thumbnail-ee1e6269398f9ecd0042b8be9733fdfc.png";